// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"404b6bd7","546":"5bc6dce0"}[chunkId] + ".chunk.css";
};